
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Web-Elements/Chatbox.html",
      function () {
        return require("private-next-pages/Web-Elements/Chatbox.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Web-Elements/Chatbox.html"])
      });
    }
  